import { render, staticRenderFns } from "./VehicleImage.vue?vue&type=template&id=37059ae0&scoped=true&"
import script from "./VehicleImage.vue?vue&type=script&lang=js&"
export * from "./VehicleImage.vue?vue&type=script&lang=js&"
import style0 from "./VehicleImage.vue?vue&type=style&index=0&id=37059ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37059ae0",
  null
  
)

export default component.exports